import pako from "pako";

export function encodeContent(text) {
  const compressed = pako.gzip(text);
  return btoa(String.fromCharCode.apply(null, Array.from(compressed)));
}
